import { Info } from "lucide-react"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip"
import type { ExtractedField } from "../types"

interface OriginalValueIndicatorProps {
  field: ExtractedField
}

export const OriginalValueIndicator = ({
  field
}: OriginalValueIndicatorProps): JSX.Element | null => {
  const originalValue = field.original_value
  if (!originalValue || originalValue === field.field_value) {
    return null
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center flex-shrink-0 w-4 h-4 text-neutral-400 hover:text-neutral-600 transition-colors"
            tabIndex={-1}
            onClick={(e) => e.stopPropagation()}
          >
            <Info className="w-3.5 h-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" align="start" className="max-w-sm">
          <span className="text-neutral-400">Extracted: </span>
          <span>{originalValue}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
